import axiosApi from '@apis/axiosApi'
import { handleError } from '@utils/commonUtils'
import * as queryString from 'query-string'

export interface INotifyUpdateDeviceToken {
  deviceToken: string
  platform: 'ios' | 'android' | 'web'
}

export type TypeId = number | string

const CHUNG = '/chung'
const TB = '/thong-bao'

export function updateDeviceToken(data: INotifyUpdateDeviceToken) {
  try {
    return axiosApi.post(`${TB}/token-thiet-bi`, {
      token: data.deviceToken,
      loaiThietBi: data.platform,
    })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

export function getListNotification(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return axiosApi.get(`${CHUNG}/thong-bao-cua-toi`, {
      params: query || {},
    })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

export function readNotification(notificationId: TypeId) {
  try {
    return axiosApi.put(`${CHUNG}/${notificationId}/doc-thong-bao`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

export function readAllNotification() {
  try {
    return axiosApi.put(`${TB}/doc-tat-ca`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

export function deleteNotification(notificationId: TypeId) {
  try {
    return axiosApi.delete(`${TB}/${notificationId}/xoa-thong-bao`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

export function deleteDeviceToken(token: string) {
  try {
    return axiosApi.delete(`${TB}/${encodeURIComponent(token)}/token-thiet-bi`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

export function sendNotification(data: { title: string; body: string; userIds: string[]; type?: string; refId?: number; data?: object }) {
  try {
    return axiosApi.post(`${TB}/push`, data)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

export function deleteMultiNotification(ids: string[]) {
  try {
    return axiosApi.delete(`${TB}/batch`, { data: { ids } })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

export function getDetailNotification(id: TypeId) {
  try {
    return axiosApi.get(`${TB}/${id}`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}
